import { get,post,put } from "./config";

export const login = async ({username,password}) => {
    const url = '/app/user/erp-login';
    const data = {
        erpId: username,
        password
    };
    return await post(url,data);
};

export const getLoginUser = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/getLoginUser?${params}`;
    return await get(url,true);
};

export const pcGetMap = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/pcGetMap?${params}`;
    return await get(url,true);
};

export const avgAll = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/avgAll?${params}`;
    return await get(url,true);
};

export const getExamResultByDate = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/getExamResultByDate?${params}`;
    return await get(url,true);
};

export const tbScoreList = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/tbScoreList?${params}`;
    return await get(url,true);
};

export const editPassword = async (data) => {
    const url = '/app/user/password';

    return await put(url,data,true);
};
export const isOldPassWord = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/isOldPassWord?${params}`;
    return await get(url,true);
};


export const getIsCode = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/getIsCode?${params}`;
    return await get(url,false);
};

export const getCode = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/getCode?${params}`;
    return await get(url,false);
};

export const verifyCode = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/verifyCode?${params}`;
    return await get(url,false);
};

export const getTenantInfo = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/getTenantInfo?${params}`;
    return await get(url,false);
};

export const register = async data => {
    const url = `/app/userNew/register`;
    return await post(url,data);
};

export const getUserInfo = async data => {
    const params = new URLSearchParams(data).toString();
    const url = `/app/userNew/getUserInfo?${params}`;
    return await get(url,false);
};




